import _ from 'lodash';

import { getDemoReportHandler } from './demo_report_metric_sets';

export const DEMO_ROUTES = [
  'answer-performance',
  'email-suggestions',
  'greeting-suggestions',
  'guide-performance',
  'liveboards',
  'phrase-suggestions',
  'recommended-answers',
  'recommended-answers-count',
  'topic-suggestions',
];

function isDemoRoute(url, getDatabase) {
  if (_.some(DEMO_ROUTES, demoRoute => url.includes(demoRoute))) {
    return true;
  }

  if (url.includes('reports')) {
    return true;
  }

  // we have a setting that allows us to use the real actions when connected
  // to a 3rd party system (i.e. Shopify)
  if (url.includes('action-forms') || url.includes('transactions')) {
    // extract the 'orgId' from the URL to see if we should
    // use real actions
    const useRealActions = getDatabase(getOrgId(url, '/customers')).useRealActions;
    return !useRealActions;
  }

  // use dataset-defined text rewrite vs real openAI text rewrite depending on the dataset
  if (url.includes('ai-text-completion')) {
    // extract the 'orgId' from the URL to look into dataset
    // and see if we should use real AI text completion
    const useRealAiTextCompletion = getDatabase(getOrgId(url, '/ai-text-completion')).useRealAiTextCompletion;
    return !useRealAiTextCompletion;
  }

  return false;
}

const DEMO_LIVEBOARD_ROUTE_PATTERN = /\/api\/v[12]\/orgs\/[^/]+\/liveboards\//;
const DEMO_REPORTS_ROUTE_PATTERN = /\/api\/reporting\/v1\/orgs\/[^/]+\/reports(\?|$)/;

export function isDemoReportingRoute(url, body) {
  if (DEMO_LIVEBOARD_ROUTE_PATTERN.test(url)) {
    return true;
  }
  if (DEMO_REPORTS_ROUTE_PATTERN.test(url)) {
    return !!getDemoReportHandler(_.get(body, 'metricSet'));
  }
  return false;
}

function getOrgId(url, afterOrgId) {
  const start = url.indexOf('orgs/') + 'orgs/'.length;
  const end = url.indexOf(afterOrgId);
  return url.substring(start, end);
}

export default class DemoRestClient {
  constructor(xhrAdapter, localRest, getDatabase, isLocalRoute = url => isDemoRoute(url, getDatabase)) {
    this._xhrAdapter = xhrAdapter;
    this._localRest = localRest;
    this._isLocalRoute = isLocalRoute;
  }

  post(url, obj, cb, opts) {
    return this._xhrAdapter.post(url, obj, cb, opts);
  }

  get(url, cb, opts) {
    if (this._isLocalRoute(url)) {
      return this._localRest.get(url, cb);
    }
    return this._xhrAdapter.get(url, cb, opts);
  }

  put(url, obj, cb, opts) {
    return this._xhrAdapter.put(url, obj, cb, opts);
  }

  postUpload(url, obj, listeners, opts) {
    return this._xhrAdapter.postUpload(url, obj, listeners, opts);
  }

  delete(url, cb, opts) {
    return this._xhrAdapter.delete(url, cb, opts);
  }

  axios() {
    return new AxiosDemoClient(this._xhrAdapter.axios(), this._localRest.axios(), this._isLocalRoute);
  }
}

class AxiosDemoClient {
  constructor(httpClient, localRestBackendAxios, isLocalRoute) {
    this._httpClient = httpClient;
    this._localRestBackendAxios = localRestBackendAxios;
    this._isLocalRoute = isLocalRoute;
  }

  get(url, config) {
    if (this._isLocalRoute(url)) {
      return this._localRestBackendAxios.get(url, config);
    }
    return this._httpClient.get(url, config);
  }

  post(url, body, config) {
    if (this._isLocalRoute(url, body)) {
      return this._localRestBackendAxios.post(url, body, config);
    }
    return this._httpClient.post(url, body, config);
  }

  put(url, body, config) {
    return this._httpClient.put(url, body, config);
  }

  delete(url, config) {
    return this._httpClient.delete(url, config);
  }

  patch(url, body, config) {
    return this._httpClient.patch(url, body, config);
  }
}
